import type { AtlasMission } from '../atlas.types';

/**
 * Post-full-update journey — wraps the existing `usePostUpdateJourney` hook
 * steps as an Atlas mission. Storage delegates to
 * `postUpdateJourneyStorageKeyV2` via the adapter, so Phase 2 adds Dock
 * visibility without touching the journey machinery.
 */
export const postUpdateJourneyMission: AtlasMission = {
  id: 'post-full-update',
  title: 'Finish the post-update walkthrough',
  description: 'Try the date filter, details tab, estimation tab, calendar, and releases.',
  kicker: 'Walkthrough',
  estimatedMinutes: 5,
  entryRoute: '/analytics',
  featureKey: 'atlas.postFullUpdate',
  storage: 'journey',
  steps: [
    {
      id: 'dateFilter',
      title: 'Try the date filter',
      body: 'Pick a quick filter or a custom range to focus the charts.',
      route: '/analytics',
    },
    {
      id: 'tabDetails',
      title: 'Explore the Details tab',
      body: 'Every worklog entry, exportable to CSV or Excel.',
      route: '/analytics',
    },
    {
      id: 'tabEstimation',
      title: 'Check estimation accuracy',
      body: 'Estimated vs. actual time — spot patterns.',
      route: '/analytics',
    },
    {
      id: 'navigateCalendar',
      title: 'Open the Calendar',
      body: 'See availability, absences, and bank holidays.',
      route: '/calendar',
    },
    {
      id: 'navigateReleases',
      title: 'Open Releases',
      body: 'Plan scope, capacity and team allocation.',
      route: '/releases',
    },
  ],
};
